import React from 'react';

const Loading = () => {
	return (
		<div class="lds-ripple"><div></div><div></div></div>
	);
};

export default Loading;